import { Loader } from 'google-maps'

export default class {
  container: HTMLElement
  map: google.maps.Map<HTMLElement> | undefined

  constructor(container: HTMLElement) {
    this.container = container
  }

  public async createMap() {
    const { container } = this

    if (container) {
      const loader = new Loader(jsData.google_api_key)

      const lat = container.getAttribute('data-lat')
      const lng = container.getAttribute('data-lng')

      const parsedLat = parseFloat(`${lat}`)
      const parsedlng = parseFloat(`${lng}`)

      const google = await loader.load()

      this.map = new google.maps.Map(container, {
        zoom: 14,
        streetViewControl: false,
        zoomControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        styles: [
          {
            featureType: 'all',
            elementType: 'geometry.fill',
            stylers: [
              {
                hue: '#ff0000',
              },
            ],
          },
          {
            featureType: 'all',
            elementType: 'labels.text',
            stylers: [
              {
                color: '#ff0000',
              },
            ],
          },
          {
            featureType: 'all',
            elementType: 'labels.text.fill',
            stylers: [
              {
                saturation: 36,
              },
              {
                color: '#000000',
              },
              {
                lightness: 40,
              },
            ],
          },
          {
            featureType: 'all',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                visibility: 'on',
              },
              {
                color: '#000000',
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            featureType: 'all',
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#000000',
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#000000',
              },
              {
                lightness: 17,
              },
              {
                weight: 1.2,
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#8395b0',
              },
            ],
          },
          {
            featureType: 'administrative.country',
            elementType: 'geometry',
            stylers: [
              {
                color: '#1e365b',
              },
            ],
          },
          {
            featureType: 'administrative.province',
            elementType: 'geometry',
            stylers: [
              {
                color: '#1e365b',
              },
            ],
          },
          {
            featureType: 'administrative.locality',
            elementType: 'geometry',
            stylers: [
              {
                color: '#1e365b',
              },
            ],
          },
          {
            featureType: 'administrative.neighborhood',
            elementType: 'all',
            stylers: [
              {
                color: '#1e365b',
              },
            ],
          },
          {
            featureType: 'administrative.land_parcel',
            elementType: 'geometry',
            stylers: [
              {
                color: '#1e365b',
              },
            ],
          },
          {
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [
              {
                color: '#000000',
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: 'landscape',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#1c2738',
              },
            ],
          },
          {
            featureType: 'landscape.man_made',
            elementType: 'geometry',
            stylers: [
              {
                color: '#1e365b',
              },
            ],
          },
          {
            featureType: 'landscape.natural',
            elementType: 'geometry',
            stylers: [
              {
                color: '#141f31',
              },
            ],
          },
          {
            featureType: 'landscape.natural',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#1e365b',
              },
            ],
          },
          {
            featureType: 'landscape.natural.landcover',
            elementType: 'geometry',
            stylers: [
              {
                color: '#1e365b',
              },
            ],
          },
          {
            featureType: 'landscape.natural.landcover',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#0e1724',
              },
            ],
          },
          {
            featureType: 'landscape.natural.landcover',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#1e365b',
              },
            ],
          },
          {
            featureType: 'landscape.natural.terrain',
            elementType: 'geometry',
            stylers: [
              {
                color: '#1e365b',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
              {
                color: '#000000',
              },
              {
                lightness: 21,
              },
            ],
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [
              {
                color: '#142745',
              },
            ],
          },
          {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#ffffff',
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#0b0f15',
              },
              {
                lightness: 17,
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#000000',
              },
              {
                lightness: 29,
              },
              {
                weight: 0.2,
              },
            ],
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [
              {
                color: '#000000',
              },
              {
                lightness: 18,
              },
            ],
          },
          {
            featureType: 'road.local',
            elementType: 'geometry',
            stylers: [
              {
                color: '#000000',
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'geometry',
            stylers: [
              {
                color: '#162233',
              },
              {
                lightness: 19,
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              {
                color: '#06202a',
              },
              {
                lightness: 17,
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#1e365b',
              },
            ],
          },
        ],
      })

      if (this.map) {
        this.createMarker(parsedLat, parsedlng)
        this.setCenter(parsedLat, parsedlng)
        window.addEventListener('resize', () => this.setCenter(parsedLat, parsedlng))
      }

      return this
    }
  }

  private setCenter(lat: number, lng: number) {
    if (this.map) {
      const _lng = window.innerWidth < 1290 ? lng : lng + 0.02
      this.map.setCenter(new google.maps.LatLng(lat, _lng))
    }

    return this
  }

  private createMarker(lat: number, lng: number) {
    const marker = jsData.theme_uri + '/dist/images/icons/marker.svg'

    return new google.maps.Marker({
      map: this.map,
      position: { lat, lng },
      icon: marker,
    })
  }
}
